// mockData.js
export const mockWaiters = [
  { id: 1, name: 'Selim', pin: '1234' },
  { id: 2, name: 'Rahim', pin: '2345' },
  { id: 3, name: 'Karim', pin: '3456' },
];

export const mockCustomers = [
  { id: 1, name: 'John ', phone: '1234567890' },
  { id: 2, name: 'Zahid Hasan', phone: '0987654321' },
  { id: 3, name: 'Yusuf ', phone: '1122334455' },
];

export const mockTables = [
  { id: 1, number: 1, capacity: 4 },
  { id: 2, number: 2, capacity: 2 },
  { id: 3, number: 3, capacity: 6 },
  { id: 4, number: 4, capacity: 6 },
  { id: 5, number: 5, capacity: 4 },
];

export const mockProducts = [
  {
    id: 1, name: 'Biriani', price: 250, category: 'Main',
  },
  {
    id: 2, name: 'Water Bottle', price: 30, category: 'Beverage',
  },
  {
    id: 3, name: 'Ice Cream', price: 60, category: 'Dessert',
  },
  {
    id: 4, name: 'Curd', price: 40, category: 'Dessert',
  },
];

export const mockOrders = [
  {
    id: 1001,
    createdAt: '2023-05-15T12:30:00',
    updatedAt: '2023-05-15T14:45:00',
    initialItems: [
      {
        productId: 1, quantity: 2, name: 'Biriani', price: 250,
      },
      {
        productId: 2, quantity: 2, name: 'Water Bottle', price: 30,
      },
      {
        productId: 3, quantity: 3, name: 'Ice Cream', price: 60,
      },
    ],
    finalItems: [
      {
        productId: 1, quantity: 2, name: 'Biriani', price: 250,
      },
      {
        productId: 2, quantity: 1, name: 'Water Bottle', price: 30,
      },
      {
        productId: 4, quantity: 1, name: 'Curd', price: 40,
      },
    ],
    total: 630,
    customerId: 2,
    waiterId: 1,
    waiterName: 'Abdul',
    tableNumber: 4,
    status: 'completed',
    notes: 'Customer changed order after meal',
  },
  // ... more orders
];
